// extracted by mini-css-extract-plugin
export var searchHeader = "_50-0";
export var searchHeaderDark = "_50-1";